import { GetState, SetState } from 'zustand';
import { SettingsStore } from 'store';

export function switchNavigationDrawer(set: SetState<SettingsStore>, get: GetState<SettingsStore>): void {
   set({ navigationDrawerOpened: !get().navigationDrawerOpened });
}
